module.exports = __webpack_public_path__ + "static/img/banner1.3703a66.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/banner1.png
// module id = +dJQ
// module chunks = 12